import React from "react";
import StartStep from "../../components/StartStep/StartStep";
import GreyCard from "../../components/GreyCard/GreyCard";
import Row from "react-bootstrap/Row";
import {Button, Col, ProgressBar} from "react-bootstrap";
import Container from "react-bootstrap/Container";

const AboutUs = () => {
    return (
        <div>
            <StartStep>
                <h1>Базовый стандарт профессиональных компетенций работников НИУ ВШЭ </h1>
            </StartStep>

            <GreyCard>
                <p>
                    <b>Базовый стандарт профессиональных компетенций работников НИУ ВШЭ </b>
                    <p>
                        – это совокупность минимально необходимых компетенций, деловых качеств, знаний и навыков,
                        которыми должен обладать каждый работник нашего университета вне зависимости от его должности
                        или возложенных на него должностных обязанностей.
                    </p>
                </p>
                <br/>
                <p><b>Базовым стандартом устанавли¬ваются разные требования к составу и уровню общих компетенций для:</b></p>
                <ul>
                    <li>Научно-педагогических работников (НПР) и тьюторов</li>
                    <li>Административно-управленческого и учебно-вспомогательного персонала (АУП и УВП), других аналогичных категорий работников университета</li>
                </ul>
                <br/>
                <p><b>В соответствии с двумя основными сферами своего применения Базовый стандарт состоит из двух разделов:</b></p>
                <ul>
                    <li>Требования к претендентам при приеме на работу в НИУ ВШЭ (входные требования)</li>
                    <li>Требования к уже работающим в университете работникам (конкурсные/аттестационные требования)</li>
                </ul>
                <br/>
                <p><a href="https://www.hse.ru/hse_competencies#bs">Входные требования при приёме на работу</a></p>
            </GreyCard>

            <br/><br/>

            <Container>
                <Row className="justify-content-md-center">
                    <Col md={2}>
                        <Button variant="outline-primary" style={{width: "100%"}} href="/step7">Назад</Button>{' '}
                    </Col>
                    <Col md={1}></Col>
                    <Col md={6} style={{ textAlign: "center", paddingTop: "6px"}}>
                        <ProgressBar now={72}/>
                        <span>Шаг 8 из 11</span>
                    </Col>
                    <Col md={1}></Col>
                    <Col md={2}>
                        <Button variant="outline-primary" style={{width: "100%"}} href="/step9">Вперед</Button>{' '}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default AboutUs;